import {lazyRegister} from "@core/lazyRegister";
import {GetLoggedInUserConfig} from './getLoggedInUser';
import {config as configNotification} from './Notification';
import {configModal} from "@core/configModal";

export const registerCore = (app: IModule) => {
    lazyRegister.setModule(app);
    configModal(app);
    GetLoggedInUserConfig.register(app);
    configNotification(app);
}
